import { PageId } from 'constants/pages'

export const enum PageIdWoofzRfnd3 {
  SEX_RFND3 = PageId.SEX_RFND3,
  DOG_AGE_RFND3 = PageId.DOG_AGE_RFND3,
  DOG_BREED_RFND3 = PageId.DOG_BREED_RFND3,
  URGE_RFND3 = PageId.URGE_RFND3,
  COMMANDS_61_RFND3 = PageId.COMMANDS_61_RFND3,
  COMMANDS_62_RFND3 = PageId.COMMANDS_62_RFND3,
  COMMANDS_63_RFND3 = PageId.COMMANDS_63_RFND3,
  URGE_RFND3_2 = PageId.URGE_RFND3_2,
  POTTY_RFND3 = PageId.POTTY_RFND3,
  BEHAVIOR_RFND3 = PageId.BEHAVIOR_RFND3,
  TRAINING_RFND3 = PageId.TRAINING_RFND3,
  PREPARE_FLOW_RFND3 = PageId.PREPARE_FLOW_RFND3,
  DOG_STATISTICS_RFND3 = PageId.DOG_STATISTICS_RFND3,
  EMAIL_RFND3 = PageId.EMAIL_RFND3,
  NEWSLETTER_URGE_RFND3 = PageId.NEWSLETTER_URGE_RFND3,
  LAST_CHANCE_OFFER_RFND3 = PageId.LAST_CHANCE_OFFER_RFND3,
  SUBSCRIPTIONS_RFND3 = PageId.SUBSCRIPTIONS_RFND3,
  CANCEL_OFFER_RFND3 = PageId.CANCEL_OFFER_RFND3,
  CHAT_UPSELL_RFND3 = PageId.CHAT_UPSELL_RFND3,
  UPSELL_RFND3 = PageId.UPSELL_RFND3,
  DOWNLOAD_RFND3 = PageId.DOWNLOAD_RFND3,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
